import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React from 'react'

const LegendInfo = (props) => {
  return (
    <CModal
      alignment="center"
      scrollable
      visible={props.infoPageModal}
      onClose={() => props.setInfoPageModal(false)}
    >
      <CModalHeader>
        <CModalTitle>Information</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p>
          <strong>SC</strong>: Score{' '}
        </p>
        <p>
          <strong>HW</strong>: Home Win
        </p>
        <p>
          <strong>AW</strong>: Away Win
        </p>
        <p>
          <strong>AL</strong>: Away Loss
        </p>
        <p>
          <strong>HL</strong>: Home Loss
        </p>
        <p>
          <strong>SSW</strong>: Single Score Win
        </p>
        <p>
          <strong>SSL</strong>: Single Score Loss
        </p>
        <p>
          <strong>OWT</strong>: Only Winner in Team
        </p>
        <p>
          <strong>BWM</strong>: Biggest Win Margin
        </p>
        <p>
          <strong>BLM</strong>: Biggest Loss Margin
        </p>

        <p>
          <strong>FP</strong>: Fantasy Points
        </p>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => props.setInfoPageModal(false)}>
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default LegendInfo
